import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})

export class FooterComponent {

  aboutText = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In at purus varius odio tempus cursus. vitae, commodo dui.";

  socialLinks = [
    { icon: 'bi-facebook', link: '/' },
    { icon: 'bi-twitter-x', link: '/' },
    { icon: 'bi-pinterest', link: '/' },
    { icon: 'bi-dribbble', link: '/' }
  ];

  recentPosts = [
    {
      image: 'assets/images/blogs/post-img-sm.jpg',
      title: 'Ut venenatis, Commodo ligula',
      desc: 'Lorem ipsum dolor sit amet, adipiscing elit...'
    },
    {
      image: 'assets/images/blogs/post-img-sm-2.jpg',
      title: 'Ut venenatis, Commodo ligula',
      desc: 'Lorem ipsum dolor sit amet, adipiscing elit...'
    }
  ];

  contactInfo = [
    {
      icon: 'bi-pin-fill',
      text: 'Schönhauser Allee 167c 10435 Berlin Germany'
    },
    {
      icon: 'bi-envelope',
      text: 'yoursite@gmail.com'
    },
    {
      icon: 'bi-phone-fill',
      text: '+49 30 47373795'
    }
  ];

}
